

export default class FileUtil {

	public static guessMimeTypeFromExtension(url: string) {

		const ext = url.slice(url.lastIndexOf('.') + 1);

		switch(ext) {

			// video
			case "mp4":
				return "video/ref";

			// audio
			case "mp3":
				return "audio/ref";

			// images
			case "gif":
			case "ico":
			case "jpeg":
			case "jpg":
			case "svg":
			case "png":
				return "image/ref";

			default:
				return "document/ref";
		}
	}

}



// WEBPACK FOOTER //
// ./src/core/util/FileUtil.ts